export const GET_SCREEN_REQUEST = "GET_SCREEN_REQUEST";
export const GET_SCREEN_SUCCESS = "GET_SCREEN_SUCCESS";
export const GET_SCREEN_FAILURE = "GET_SCREEN_FAILURE";
export const GET_KYC_PAGE_LIST = "GET_KYC_PAGE_LIST";

export const UPDATE_SCREEN_PAGE = "UPDATE_SCREEN_PAGE";
export const UPDATE_DIGILOCKER = "UPDATE_DIGILOCKER";
export const SET_ADDRESS_FORCEFULLY = "SET_ADDRESS_FORCEFULLY";
export const SET_PD_FORCEFULLY = "SET_PD_FORCEFULLY";
export const SET_FORECEFULLY_STATE = "SET_FORECEFULLY_STATE";
export const KYC_STATUS_SUCCESS = "KYC_STATUS_SUCCESS";
export const UPDATE_NAVIGATION_KYC_STATUS = "UPDATE_NAVIGATION_KYC_STATUS";
